import React, { createContext, useContext, useState } from 'react';

const ReturnProcessContext = createContext();

export const ReturnProcessProvider = ({ children }) => {
  const [returnData, setReturnData] = useState({
    labelPackage: {
      files: {},
      packageType: ''
    },
    pickupLocation: null,
    pickupTime: null,
    dropoffLocation: null,
  });

  const updateReturnData = (step, data) => {
    setReturnData(prev => ({
      ...prev,
      [step]: {
        ...prev[step],
        ...data
      }
    }));
  };

  return (
    <ReturnProcessContext.Provider value={{ returnData, updateReturnData }}>
      {children}
    </ReturnProcessContext.Provider>
  );
};

export const useReturnProcess = () => {
  const context = useContext(ReturnProcessContext);
  if (!context) {
    throw new Error('useReturnProcess must be used within a ReturnProcessProvider');
  }
  return context;
};





